import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=1daedc70&scoped=true&"
import script from "./OrderOverview.vue?vue&type=script&lang=js&"
export * from "./OrderOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=1daedc70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daedc70",
  null
  
)

export default component.exports